import React, { useState, useEffect } from "react";
import FileIcon from "src/img/notice/document.svg";
import { PlayIcon } from "src/components";
import { decryptEncryptedFile, fetchMatrixMedia, mxcToHttp } from "src/scenes/Chat/utils";
import { PlayIconOverlay, StyledImage,
    StyledVideo, StyledFileIcon,
    MediaPreviewWrapper, FileAttachment,
} from "./styled";

/**
 * Displays message content preview (for replies, edits).
 * @param {{ content: object, matrixClient: any }} props
 */
export const MessageContentDisplay = ({ content, matrixClient }) => {
    const [mediaUrl, setMediaUrl] = useState(null);

    useEffect(() => {
        const loadMedia = async () => {
            if (!content || !matrixClient) return;

            let rawUrl = content.url;
            if (rawUrl && typeof rawUrl === "object" && rawUrl.content_uri) {
                rawUrl = rawUrl.content_uri;
            }

            if (content?.file?.v === "v2") {
                try {
                    const resp = await fetchMatrixMedia(content.file.url, matrixClient);
                    const blob = await resp.blob();
                    const decryptedBlob = await decryptEncryptedFile(blob, content.file, content.info?.mimetype);
                    const blobUrl = URL.createObjectURL(decryptedBlob);
                    setMediaUrl(blobUrl);
                } catch (e) {
                    console.error("Failed to decrypt edit/reply preview media", e);
                }
            } else {
                // Unencrypted
                if (typeof rawUrl === "string") {
                    setMediaUrl(mxcToHttp(rawUrl, matrixClient.baseUrl));
                }
            }
        };

        loadMedia();
    }, [content, matrixClient]);

    if (!content) return null;

    let rawUrl = content.url;
    if (rawUrl && typeof rawUrl === "object" && rawUrl.content_uri) {
        rawUrl = rawUrl.content_uri;
    }

    return (
        <ReplyMediaPreview
            type={content.msgtype}
            src={mediaUrl}
            value={content.body}
            alt="Edit & reply preview"
            width={content.msgtype === "m.file" ? "auto" : "5rem"}
            height={content.msgtype === "m.file" ? "auto" : "4rem"}
            background="transparent"
            padding="0px"
            isEditReply={true}
        />
    );
};

/**
 * Displays media or file type preview (text on edit, image, video, file).
 * @param {{
 *   type: string;
 *   src: string;
 *   value: string;
 *   alt: string;
 *   onClick?: () => void;
 *   width?: string;
 *   height?: string;
 *   background?: string;
 *   padding?: string;
 *   isEditReply?: boolean;
 * }} props
 */
export const ReplyMediaPreview = ({ type, src, value, alt, onClick, width, height, background, padding, isEditReply,
}) => {
    if (type === "m.text" && isEditReply) {
        return <span>{value}</span>;
    }
    return (
        <MediaPreviewWrapper
            onClick={onClick}
            width={width}
            height={height}
            background={type === "m.file" ? "transparent" : background}
            padding={type === "m.file" ? "0px" : padding}
        >
            {type === "m.image" && <StyledImage src={src} alt={alt} />}
            {type === "m.video" && (
                <>
                    <StyledVideo src={src} muted preload="metadata" />
                    <PlayIconOverlay alt="Play Video" width="24px" height="16px">
                        <PlayIcon/>
                    </PlayIconOverlay>
                </>
            )}
            {type === "m.file" && (
                <FileAttachment background={isEditReply ? "#f0f0f0" : "#DBE5ED"} height={"40px"}>
                    <StyledFileIcon src={FileIcon} alt="File" /> {value}
                </FileAttachment>
            )}
        </MediaPreviewWrapper>
    );
};
